import React, { InputHTMLAttributes, useCallback, useEffect, useState } from 'react'
import { Cause } from '../../../types/Causes'
import { Target } from '../../../types/Target'
import { CheckItem } from '../../CheckItem'




export const DataChecks = ({ data, unique, select, selects, maxValue, label, ...props }: Props) => {

    const [selected, setSelected] = useState<string>(select ? select : "")
    const [selecteds,] = useState<string[]>(selects ? selects : [])
    const [countCheck, setCount] = useState<number>(0)
    const [isBlock,setIsBlock] = useState<boolean>(false)

    const handleCount = useCallback((opt: boolean) => {
        setCount(count => opt ? count + 1 : count - 1)
    }, [setCount])


    useEffect(() => {
        let count:number = 0;
        let checkboxes = document.querySelectorAll('input[type="checkbox"]:checked');
        checkboxes.forEach(item => {
            if (item.className === props.name)
                count++
        })
        if (!maxValue) return setIsBlock(false)
        if (count >= maxValue) return setIsBlock(true)
        return setIsBlock(false)
    }, [countCheck, maxValue,props,setIsBlock])


    return (
        <div className='mt-3'>
            <label className='flex justify-between'>
                <div className='flex items-center font-semibold'>
                    {label}
                </div>
            </label>
            <div className='grid grid-cols-2 mt-2'>
                {data.map(item => (
                    <div key={item.id} className={"cursor-pointer"}>
                        {unique ?
                            <CheckItem {...props} onClick={() => setSelected(item.id)} type={"radio"}
                               value={selected} defaultValue={item.id} label={item.name} defaultChecked={selected === item.id && true}
                            />
                            :
                            <CheckItem  {...props} className={props.name} countFuction={handleCount} block={isBlock} type={"checkbox"} defaultValue={item.id} defaultChecked={selecteds.find(find => find === item.id) ? true : false} label={item.name} />
                        }

                    </div>
                ))}
            </div>
        </div>
    )
}

interface Props extends InputHTMLAttributes<HTMLInputElement> {
    label: string,
    data: Cause[] | Target[]
    unique?: boolean,
    select?: string,
    selects?: string[],
    maxValue?: number
}
